import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import { useHistory, Link } from "react-router-dom";
import "./Login.css";

const Login = () => {
  const { enqueueSnackbar } = useSnackbar(),
    [uname, setUname] = useState(""),
    [passwd, setPasswd] = useState(""),
    history = useHistory();

  const setFns = { setUname, setPasswd };
  function handleChange(e) {
    const { name, value } = e.target;
    setFns[`set${name}`](value);
  } 

  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */
   const login = async () => {
    if (!validateInput())
      return;

    const formData = { username: uname, password: passwd };
    let msg, variant = "error";

    try {
      const response = await axios.post(
        `${config.endpoint}/auth/login`, formData, {
          validateStatus: status => status >= 200 && status < 500
      });
      const data = response.data;
      msg = data.message; 
      
      if (data.success) {
        variant = "success";
        msg = "Logged in Successfully";
        const { token, balance } = data;
        persistLogin(token, uname, balance);
      }
    } catch (e) {
      msg = "Something went wrong. Check that the backend is running, reachable and returns valid JSON.";
    }  
    enqueueSnackbar(msg, { variant });
    if (variant === 'success')
      history.push('/');
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */
  const validateInput = () => {
    
      let msg;
      if (uname === '')
        msg = 'Username is a required field';
      
      else if (passwd === '')
        msg = "Password is a required field"; 
      
      if (msg) {
        enqueueSnackbar(msg, { variant: 'error' });
        return false;
      }
  
      return true;
    
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  const persistLogin = (token, username, balance) => {
    localStorage.setItem('token', token);
    localStorage.setItem('username', username);
    localStorage.setItem('balance', balance);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      
      <Header hasHiddenAuthButtons/>
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Login</h2>
          <TextField
            label="Username"
            type="text"
            variant="outlined"
            name="Uname"
            onChange={handleChange}
            value={uname}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            name="Passwd"
            onChange={handleChange}
            value={passwd}
          />
          <Button variant="contained" onClick={login}>
            Login to QKart
          </Button>
          <p className="secondary-action">
            Don't have an account? <Link to="/register">Register Now</Link>
          </p>
        </Stack>
      </Box>
      <Footer />
      <Footer />
    </Box>
  );
};

export default Login;
